import { createSlice } from '@reduxjs/toolkit';
import { toggleOpenAction } from '../../../actions/WidgetActions';
const initialState = {
  shown: false,
  dismissed: false
};
const spotlightWelcomeMessagePopupSlice = createSlice({
  name: 'spotlightWelcomeMessagePopup',
  initialState,
  reducers: {
    showWelcomeMessagePopup: state => {
      state.shown = true;
    },
    dismissWelcomeMessagePopup: state => {
      state.dismissed = true;
    }
  },
  extraReducers: builder => {
    // If the visitor opens the widget before the 30s timer fires, the popup
    // must never appear later in the session — they've already engaged.
    builder.addCase(toggleOpenAction, (state, action) => {
      if (action.payload.isOpened) {
        state.dismissed = true;
      }
    });
  }
});
export const {
  showWelcomeMessagePopup,
  dismissWelcomeMessagePopup
} = spotlightWelcomeMessagePopupSlice.actions;
export default spotlightWelcomeMessagePopupSlice.reducer;